import { COLOR } from 'src/constants/colors'
import { GnbListType } from 'src/types/types'
import Svg from 'src/components/atomic/atom/Svg'
import Span from 'src/components/atomic/atom/Span'
import Div from 'src/components/atomic/atom/Div'
import useMediaQueryHook from 'src/hooks/useMediaQuery.hook'
import { useTranslation } from 'react-i18next'
import useMatchHook from 'src/hooks/useMatch.hook'
import { MouseEvent } from 'react'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import usePromptHook from 'src/hooks/usePrompt.hook'
import CustomNavLink from 'src/components/atomic/atom/CustomNavLink'

const MoGnb = () => {
  const { t } = useTranslation()
  const { setMediaStyle, currentMedia } = useMediaQueryHook()
  const { CameraStatus } = useAppSelector((state: RootState) => state.CameraPage)
  const { PromptNavLinkHandler } = usePromptHook(CameraStatus !== 'default')
  const { m_explorer, m_home, m_camera, m_location } = useMatchHook()
  const MoGnbList: GnbListType[] = [
    {
      text: t('MENU.HOME', { defaultValue: 'Home' }) as string,
      svg: m_home ? 'home_active' : 'home',
      size: { width: '24', height: '24' },
      path: '/home',
      matchPath: m_home,
      className: 'menu_home',
    },
    {
      text: t('MENU.LOCATE_DEVICE', { defaultValue: 'Locate Device' }) as string,
      svg: m_location ? 'locate_active' : 'locate',
      size: { width: '24', height: '24' },
      path: '/location',
      matchPath: m_location,
      className: 'menu_locate_device',
    },
    {
      text: t('MENU.FILE_EXPLORER', { defaultValue: 'File Explorer' }) as string,
      svg: m_explorer ? 'file_active' : 'file_grey',
      size: { width: '20', height: '24' },
      path: '/explorer',
      matchPath: m_explorer,
      className: 'menu_file_explorer',
    },
    {
      text: t('MENU.VIDEO_CALL', { defaultValue: 'VideoCall' }) as string,
      svg: m_camera ? 'video_call_active' : 'video_call',
      size: { width: '24', height: '24' },
      path: '/camera',
      matchPath: m_camera,
      className: 'menu_video_call',
    },
  ]

  const GnbWrapStyle = {
    top: `calc(100% - 64px)`,
    position: 'fixed',
    bottom: '0',
    left: '50%',
    transform: 'translate(-50%, 0)',
    boxShadow: '0px -3px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '12px 12px 0 0',
    zIndex: 9996,
  }

  return (
    <>
      {(m_home || m_location || m_explorer || m_camera) !== null && (
        <Div
          width={'100%'}
          height={'64px'}
          display={setMediaStyle('none', 'flex', 'flex')}
          $justify_content={'space-between'}
          style={GnbWrapStyle}
        >
          {MoGnbList.map((element: GnbListType, index) => (
            <CustomNavLink
              width={'25%'}
              key={element.text}
              link={element.path}
              className={element.className}
              onClick={(e: MouseEvent<HTMLAnchorElement>) => PromptNavLinkHandler(e, element.path)}
              $border_radius={index === 0 ? '12px 0 0 0' : index === 3 ? '0 12px 0 0' : 'unset'}
            >
              <Div
                display={'flex'}
                $flex_direction={'column'}
                $justify_content={'center'}
                height={'100%'}
              >
                <Svg name={element?.svg} width={element.size.width} height={element.size.height} />
                <Span
                  $margin={currentMedia === 'min' ? '0 auto' : '0'}
                  width={currentMedia === 'min' ? '45px' : 'auto'}
                  fontSize={'11px'}
                  $line_height={currentMedia === 'min' ? '12px' : '22px'}
                  fontFamily={'NotoSansRegular'}
                  color={element.matchPath ? COLOR.white : COLOR.black40}
                >
                  {element.text}
                </Span>
              </Div>
            </CustomNavLink>
          ))}
        </Div>
      )}
    </>
  )
}
export default MoGnb
